import * as fetch from '../fetch'

export function github_redirect(data){
	return fetch.main_public_fetch({
		url: '/social/github/redirect',
		method: 'get',
	})
}

export function github_login(data){
	return fetch.main_public_fetch({
		url: '/social/github/login',
		method: 'get',
		params: data,
	})
}

export function github_register(data){
	return fetch.main_public_fetch({
		url: '/social/github/register',
		method: 'post',
		data,
	})
}


export function gitlab_redirect(data){
	return fetch.main_public_fetch({
		url: '/social/gitlab/redirect',
		method: 'get',
	})
}

export function gitlab_login(data){
	return fetch.main_public_fetch({
		url: '/social/gitlab/login',
		method: 'get',
		params: data,
	})
}

export function gitlab_register(data){
	return fetch.main_public_fetch({
		url: '/social/gitlab/register',
		method: 'post',
		data,
	})
}